export default function LectuseInfo({ name, nummber, duration }) {
  return (
    <li className="d-flex gap-3 justify-content-between align-items-center p-3 my-3 rounded">
      <div className="text">
        <p className="fs-6">{name}</p>
        <span className="text-muted">Lesson 0{nummber}</span>
      </div>
      <span className="btn btn-secondary disabled">
        <svg
          className="me-2"
          xmlns="http://www.w3.org/2000/svg"
          width={"15px"}
          fill="black"
          viewBox="0 0 512 512"
        >
          <path d="M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z" />
        </svg>
        {duration}
      </span>
    </li>
  );
}
